import { render, staticRenderFns } from "./RegistrationCard.vue?vue&type=template&id=b6ce6598&scoped=true"
import script from "./RegistrationCard.vue?vue&type=script&lang=js"
export * from "./RegistrationCard.vue?vue&type=script&lang=js"
import style0 from "./RegistrationCard.vue?vue&type=style&index=0&id=b6ce6598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ce6598",
  null
  
)

export default component.exports